import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var DividerStyle = function DividerStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    titleColor2 = _getThemeData.titleColor2,
    lineColor2 = _getThemeData.lineColor2,
    titleColor3 = _getThemeData.titleColor3;
  var _getThemeData2 = getThemeData(props, 'divider'),
    fontSize12px = _getThemeData2.fontSize12px,
    lineHeight20px = _getThemeData2.lineHeight20px;
  return css([".c7n-divider.c7n-divider{background:", ";&-horizontal{margin:16px 0;&.c7n-divider-dashed{background:none;border-color:", ";}&.c7n-divider-with{&-text,&-text-left,&-text-right{background:none;font-size:", "px;color:", ";line-height:", "px;:before,:after{border-color:", ";}}}}.c7n-divider-inner-text{padding:0 0.08rem;}&-vertical{background:", ";height:0.12rem;}}"], lineColor2, lineColor2, fontSize12px, titleColor3, lineHeight20px, lineColor2, lineColor2);
};
export default DividerStyle;